import { lazy, Suspense } from "react";

import RouteLoadingIndicator from "@src/components/RouteLoadingIndicator/RouteLoadingIndicator";

const LazyContainer = lazy(() => import("./Account.container"));

const Container = () =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LazyContainer />
  </Suspense>;

export default Container;
